import type { GencowProcedureDef } from "@gencow/core";
import type { GencowConfig } from "@gencow/core";
import { isCloudFeatureEnabled } from "../cloud-features.js";
import { collectRagBuiltinProcedureMaps } from "./rag/procedures.js";

type BuiltinProcedureMaps = {
  queryProcedureMap: Map<string, GencowProcedureDef<"query", any, any, any>>;
  mutationProcedureMap: Map<string, GencowProcedureDef<"mutation", any, any, any>>;
};

export function collectBuiltinProcedureMaps(config: Pick<GencowConfig, "cloudFeatures"> | undefined) {
  const queryProcedureMap = new Map<string, GencowProcedureDef<"query", any, any, any>>();
  const mutationProcedureMap = new Map<string, GencowProcedureDef<"mutation", any, any, any>>();

  if (isCloudFeatureEnabled(config, "rag")) {
    mergeInto({ queryProcedureMap, mutationProcedureMap }, collectRagBuiltinProcedureMaps());
  }

  return { queryProcedureMap, mutationProcedureMap };
}

function mergeInto(target: BuiltinProcedureMaps, source: BuiltinProcedureMaps): void {
  for (const [name, def] of source.queryProcedureMap) target.queryProcedureMap.set(name, def);
  for (const [name, def] of source.mutationProcedureMap) target.mutationProcedureMap.set(name, def);
}
